<template>
  <div class="personal-box">
    <ax-header></ax-header>
    <router-view></router-view>
  </div>
</template>
<script>
import axheader from '../../components/AXheader.vue'
export default {
  components: {
    'ax-header': axheader
  },
}
</script>
